import { apiClient } from "../../../../lib/api-client";
import { useQuery } from '@tanstack/react-query';
import { MyAccountInformation } from "../types/MyAccountInformation";
import { useAuth } from "../../../../contexts/auth";

export const useGetMyAccountInformation = () => {

    const { user } = useAuth();
    const { data, isLoading } = useQuery({
        queryKey: ['my-account-information', user?.userName],
        queryFn: async () => await apiClient.get('my-account/information') as MyAccountInformation,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || undefined,
        isLoading: isLoading
    };
};
